// export const serverUrl = `http://localhost:3004`;
export const serverUrl = `https://server6.tradelink.co.il`;
